import { render, staticRenderFns } from "./ReviewMetrics.vue?vue&type=template&id=2cd617eb"
import script from "./ReviewMetrics.vue?vue&type=script&lang=js"
export * from "./ReviewMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports